var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isDisplay)?_c('b-button',{staticClass:"p-1",attrs:{"variant":"outline-info","size":"sm","disabled":_vm.disabled},on:{"click":_vm.openHealthLinkWindow}},[_c('img',{staticStyle:{"width":"auto","height":"22px","border-radius":"3px"},attrs:{"src":_vm.HLlogo}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }